import { TRANSPARENT } from '../theme/settings';

export const overrides = {
    MuiCheckbox: {
        root: {
            border: `1px solid ${TRANSPARENT}`,
            boxShadow: `inset 0 2px 0 0 ${TRANSPARENT}`,
            borderRadius: '3px',

            '& + .MuiFormControlLabel-label': {
                fontSize: 'inherit',
                marginLeft: '0.45em',
                lineHeight: 1.2
            },

            '& .NeptuneCheckbox-icon': {
                position: 'absolute',
                background: TRANSPARENT,
                borderRadius: '50%'
            },

            '& .NeptuneCheckbox-checkedIcon': {
                position: 'absolute',
                left: '0',
                right: '0',
                top: '1px',
                bottom: '0',
                height: '18px',
                width: '18px'
            }
        }
    }
};
